import { number, object, string } from "yup";

import { ChartOfAccountTypeEnum } from "@/features/chart-of-accounts";
import { EntityTypeEnum } from "@/features/outlet-chart-of-account-transactions";

const ENTITY_REQUIRED_TYPES = [
  ChartOfAccountTypeEnum.ACCOUNTS_PAYABLE,
  ChartOfAccountTypeEnum.ACCOUNTS_RECEIVABLE,
];

export const TRANSACTION_TYPE_OPTIONS = Object.freeze({
  DEBIT: "DEBIT",
  CREDIT: "CREDIT",
});

export const DEFAULT_VALUES = {
  outletChartOfAccount: null,
  type: TRANSACTION_TYPE_OPTIONS.DEBIT,
  amount: 0,
  note: "",
  entityType: null,
  entity: null,
};

export const VALIDATION_SCHEMA = object().shape({
  outletChartOfAccount: object().required("Harus diisi"),
  type: string()
    .oneOf([TRANSACTION_TYPE_OPTIONS.DEBIT, TRANSACTION_TYPE_OPTIONS.CREDIT])
    .required("Harus diisi"),
  amount: number()
    .transform((value, originalValue) =>
      originalValue === "" ? 0 : value
    )
    .moreThan(0, "Harus lebih dari 0")
    .required("Harus diisi"),
  note: string().nullable(),
  entityType: string()
    .nullable()
    .when("outletChartOfAccount", {
      is: (ocoa) => ocoa && ENTITY_REQUIRED_TYPES.includes(ocoa.type),
      then: (schema) =>
        schema
          .oneOf(
            [
              EntityTypeEnum.SUPPLIER,
              EntityTypeEnum.CUSTOMER,
              EntityTypeEnum.OUTLET,
            ],
            "Harus diisi"
          )
          .required("Harus diisi"),
      otherwise: (schema) => schema.nullable(),
    }),
  entity: object()
    .nullable()
    .when("outletChartOfAccount", {
      is: (ocoa) => ocoa && ENTITY_REQUIRED_TYPES.includes(ocoa.type),
      then: (schema) => schema.required("Harus diisi"),
      otherwise: (schema) => schema.nullable(),
    }),
});

export const isEntityRequiredType = (type) => ENTITY_REQUIRED_TYPES.includes(type);
